export interface UpdatePlanningData {
  staffDeletion?: any[] | null;
  createdBy?: string;
  createdDate?: string;
  departmentId: string;
  locationDepartmentId: string
  locationId: string
  modifiedBy?: string
  modifiedDate?: string;
  month: number;
  year: number;
  status: PlanningAction;
  planningSheet: PlanningAllocationList[] | null;
  staffs : GroupedbyMemberType[] | null;
  cancelledLeaves?: string[] | null
}

export enum PlanningAction {
  Published = 'published',
  Saved = 'saved',
  Reset = 'reset',
  Generate = 'generated',
  notPlanned = 'not_planned'
}

export enum AllocationType {
  Duty = 'DUTY',
  Activity = 'ACTIVITY',
  Both = 'BOTH',
  Empty = 'EMPTY'
}

export interface PlanningAllocationList {
  date: string;
  allocations: PlanningAllocation[] | null;
}

export interface PlanningAllocation {
  planningActivityDutyId: string;
  staffId: string;
  allocationId: string;
  allocationType: AllocationType;
  name: string;
  icon: string;
  iconType: string | null;
  iconColour: string | null;
  colourCode: string | null;
  events: PlanningEvent[] | null;
  dutyHours?: number;
  approvedLeave?: boolean | null;
  wishedRequest?:string | null;
  leaveId?: string | null;
  createdByManager?:boolean | null;
  externalAllocation: boolean | null;
  shiftType?: string | null;
  isLeave?:boolean;
  activityType?: string;
  parentDutyId?:string;
  firstSlotStartTime?:string;
  firstSlotEndTime?:string;
  secondSlotStartTime?:string;
  secondSlotEndTime?:string;
  planningDepartmentId?:string | null;
  parentStaffId?: string | null;
}

export interface PlanningEvent {
  id: string;
  name: string;
  icon: string;
  colorCode: string;
}

export interface Staff {
  leaveTypes?: any[];
  staffId: string;
  name: string;
  profilePic: string,
  employee: boolean,
  jobPercentage: number,
  totalHours: number,
  bgTargetHours: number
  totalPlannedHours: number,
  carryOverHours: number,
  bgBalance: number
  leavesCount: number,
  complimentaryHolidays: number,
  planningDepartmentId?: string,
  planningDepartmentName?:string
}

export interface GroupedbyMemberType {
  id: string,
  memberType: string;
  children: Staff[] | null
}